import { Component, Vue } from 'vue-property-decorator'
import { getUser } from '@/utils/common'
import { getModule } from 'vuex-module-decorators'
import { useConvenios, useHospitais, useMedicos } from '@/composables'
import BackofficeChatStore from '../store/backoffice-chat-store'

@Component
export default class ComponentFilter extends Vue {
  filter() {
    this.backofficeChatStore.loadChats()
    this.ga('backoffice-chat', 'filtro-chat')
  }

  resetFilter() {
    this.backofficeChatStore.resetFilter()
    this.backofficeChatStore.loadChats()
  }

  get doctors() {
    return useMedicos.medicosByCurrentUser
  }

  get hospitais() {
    return useHospitais.hospitaisByCurrentUser
  }

  get convenios() {
    return useConvenios.conveniosByCurrentUser
  }

  async fetchDoctors() {
    await useMedicos.loadMedicosByCurrentUser()
  }
  
  async fetchHospitais() {
    await useHospitais.loadHospitaisByCurrentUser()
  }
  
  async fetchConvenios() {
    await useConvenios.loadConveniosByCurrentUser()
  }

  get filterData() {
    return this.backofficeChatStore.filter
  }

  get backofficeChatStore() {
    return getModule(BackofficeChatStore, this.$store)
  }

  ga(event: string, action: string) {
    const user = getUser()
    this.$ga.event(event, action, user.profile.email)
  }
}
